'use strict';

exports.__esModule = true;

var _utils = require('./utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// utils


/**
 * @private
 *
 * @class Cache
 *
 * @classdesc
 * class that is similar to the Map infrastructure, but faster and
 * more targeted to moize use cases
 */


// types
var Cache = function () {
  function Cache() {
    _classCallCheck(this, Cache);

    this.lastItem = {};
    this.list = [];
    this.size = 0;
  }

  /**
   * @function add
   * @memberof Cache
   * @instance
   *
   * @description
   * add a new item to cache
   *
   * @param {*} key the key to assign
   * @param {*} value the value to assign at key
   */
  Cache.prototype.add = function add(key, value) {
    this.lastItem = (0, _utils.unshift)(this.list, {
      key: key,
      value: value
    });

    this.size++;
  };

  /**
   * @function clear
   * @memberof Cache
   * @instance
   *
   * @description
   * clear the cache of all items
   */


  Cache.prototype.clear = function clear() {
    this.lastItem = {};
    this.list.length = this.size = 0;
  };

  /**
   * @function expireAfter
   * @memberof Cache
   * @instance
   *
   * @description
   * remove from cache after maxAge time has passed
   *
   * @param {*} key the key to remove
   * @param {number} maxAge the time in milliseconds to wait before removing the key
   * @param {Function} onExpire a callback that is called after removing the key
   */


  Cache.prototype.expireAfter = function expireAfter(key, maxAge, onExpire) {
    var _this = this;

    setTimeout(function () {
      _this.remove(key);

      if ((0, _utils.isFunction)(onExpire)) {
        // $FlowIgnore onExpire is a function
        onExpire(key.key);
      }
    }, maxAge);
  };

  /**
   * @function get
   * @memberof Cache
   * @instance
   *
   * @description
   * get the value of an item from cache if it exists
   *
   * @param {*} key the key to get the value of
   * @returns {*} the value at key
   */


  Cache.prototype.get = function get(key) {
    if (!this.size) {
      return;
    }

    if (key === this.lastItem.key) {
      return this.lastItem.value;
    }

    var index = (0, _utils.findIndexAfterFirst)(this.list, key);

    if (~index) {
      this.lastItem = this.list[index];

      return (0, _utils.unshift)((0, _utils.splice)(this.list, index), this.lastItem).value;
    }
  };

  /**
   * @private
   *
   * @function has
   *
   * @description
   * does the key exist in the cache
   *
   * @param {*} key the key to find in cache
   * @returns {boolean} does the key exist in cache
   */


  Cache.prototype.has = function has(key) {
    return this.size !== 0 && (key === this.lastItem.key || !!~(0, _utils.findIndexAfterFirst)(this.list, key));
  };

  /**=
   * @function remove
   * @memberof Cache
   * @instance
   *
   * @description
   * remove the item at key from cach
   *
   * @param {*} key the key to remove from cache
   * @returns {void}
   */


  Cache.prototype.remove = function remove(key) {
    var index = (0, _utils.findIndex)(this.list, key);

    if (~index) {
      (0, _utils.splice)(this.list, index);

      if (this.size === 1) {
        return this.clear();
      }

      this.size--;

      if (!index) {
        this.lastItem = this.list[0];
      }
    }
  };

  /**
   * @function update
   * @memberof Cache
   * @instance
   *
   * @description
   * update an item in-place with a new value
   *
   * @param {*} key key to update value of
   * @param {*} value value to store in the map at key
   */


  Cache.prototype.update = function update(key, value) {
    var index = (0, _utils.findIndex)(this.list, key);

    if (~index) {
      this.list[index].value = value;

      if (this.lastItem && key === this.lastItem.key) {
        this.lastItem.value = value;
      }
    }
  };

  return Cache;
}();

exports.default = Cache;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/moize/lib/Cache.js
// module id = ./node_modules/moize/lib/Cache.js
// module chunks = 2345137460201621000 9249036036638527000 16304781003358073000